import React, { useEffect, useContext, useState, useRef } from 'react'
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, connectSearchBox, connectInfiniteHits, connectPagination, RangeInput, CurrentRefinements, Configure, connectRefinementList } from 'react-instantsearch-dom';

import ProductList from './ProductList'
import {Plus} from '@styled-icons/boxicons-regular/Plus'
import {Search} from '@styled-icons/evaicons-solid/Search'
import {FilterRight as Filter} from '@styled-icons/bootstrap/FilterRight'
import { FirebaseContext } from './Firebase'
import { useDebouncedCallback } from 'use-debounce'
import { useTranslation } from 'next-i18next'
import {ArrowBack} from '@styled-icons/boxicons-regular/ArrowBack'

import { typesenseInstantsearchAdapter } from "./typesenseInstantsearchAdapter"
import { typesenseInstantsearchAdapter_productCatalog } from "./typesenseInstantsearchAdapter_productCatalog"

const searchClient = typesenseInstantsearchAdapter.searchClient
const searchClient_productCatalog = typesenseInstantsearchAdapter_productCatalog.searchClient
export {searchClient}
import usePrevious from './usePrevious'

import Loading from "./Loading"

const CustomHits = ({ hits, addProduct, triggerScrollToTop, InnerButton, hasMore, refineNext, onDelete, hideIds }) => {
    const scrollRef = useRef(null)
    const sentinelRef = useRef(null)

    useEffect(() => {
        if(!triggerScrollToTop) return
        scrollRef.current.scrollTop = 0
        scrollRef.current.scrollIntoView()
    }, [triggerScrollToTop])

    const filteredHits = hits.filter(hit => !hideIds.includes(hit.id))
    filteredHits.forEach(h => { 
        delete h._highlightResult
        delete h._snippetResult
        delete h.__position
    })

    useEffect(() => {
      if (sentinelRef.current !== null) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && hasMore) {
              refineNext()
            }
          })
        })

        observer.observe(sentinelRef.current)

        return () => {
          observer.disconnect()
        }
      }
    }, [hasMore, refineNext])
    
    return (
    <div className="flex-1 overflow-auto h-auto" ref={scrollRef}>
         <ProductList products={filteredHits} 
                    onClick={addProduct} 
                    showExternalLink={true}
                    InnerButton={InnerButton} onDelete={onDelete}/>
        <div ref={sentinelRef} className="h-40">
          {hasMore && <Loading />}
        </div>
    </div>)}
const Hits = connectInfiniteHits(CustomHits)

const CustomRefinementList = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
}) => (
  <ul className='flex overflow-x-auto'>
    {items.map(item => (
      <li key={item.label}>
        <a
          href={createURL(item.value)}
          onClick={event => {
            event.preventDefault()
            refine(item.value)
          }}
          title={item.count}
          className={`whitespace-nowrap inline-block text-sm my-3 mx-1 px-4 py-2 rounded-full hover:outline-none hover:opacity-70 ${item.isRefined ? "text-pink-800 bg-pink-100 font-bold" : "text-gray-800 bg-gray-200"}` }
        >
          {isFromSearch ? (
            <Highlight attribute="label" hit={item}/>
          ) : (
            item.label
          )}
        </a>
      </li>
    ))}
  </ul>
)
const RefinementList = connectRefinementList(CustomRefinementList)

const CustomSearchBox = ({ currentRefinement, isSearchStalled, refine, onClose, indexName, focusOnload = true }) => {
    const inputSearch = useRef(null)
    const [isFilter, setIsFilter] = useState(false)
    const [value, setValue] = useState(currentRefinement)
    const { t, i18n } = useTranslation()

    useEffect(() => {
        if (focusOnload && inputSearch.current) {
            inputSearch.current.focus()
        }
    }, [])

    const onChange = e => {
      const value = e.target.value
      setValue(value)
      debouncedOnChange.callback(value)
    }

    const debouncedOnChange = useDebouncedCallback(value => refine(value), 600)

    return (
        <>
    <form noValidate action="" onSubmit={event => event.preventDefault()} role="search" className="flex items-center w-full px-5 shadow-none outline-none ring-0 rounded-none border-b">
        {onClose && <a onClick={event => {event.preventDefault(); onClose()}} className="text-gray-800 p-1  mr-5 h-12 w-12 cursor-pointer bg-gray-100 flex items-center justify-center rounded-full focus:outline-none hover:opacity-70"><ArrowBack className="h-6" /></a>}
        <label htmlFor="search-input" className="text-gray-400 pl-1 pr-3"><Search className="h-6" /></label>
      <input
        ref={inputSearch}
        id="search-input"
        type="search"
        value={value}
        onChange={onChange}
        placeholder={t('search.placeholder')}
        autoComplete="off"
        className="flex-1 h-full w-full py-6 pr-4 bg-transparent border-0 focus:text-gray-900 text-gray-500 placeholder-gray-500 shadow-none outline-none ring-0 focus:ring-0 truncate text-lg leading-normal appearance-none rounded-none transition-colors duration-200 ease-in-out"
      />
      <a href="" onClick={event => {event.preventDefault(); setIsFilter(isFilter => !isFilter)}} className={`text-gray-600 mr-2 p-3 flex items-center ${isFilter ? 'text-pink-600 bg-pink-100 rounded-full' : ''}`}><Filter className="h-5" /></a>
    </form>
        <div className={`flex ${!isFilter ? 'hidden' : ''}`}>
                    {indexName != "productCatalog" && <RefinementList attribute="merchant_name" />}
                    {/* <b>{t('search.price')}</b> 
                    <RangeInput 
                        attribute="price" 
                        translations={{
                            submit: 'ok',
                            separator: t('search.to'),
                        }
                    }/> */}
                </div>
    </>
  )}
  const SearchBox = connectSearchBox(CustomSearchBox)

  const A = props => (
    <a
      {...props}
      className="inline-block text-sm my-3 mx-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-full focus:outline-none disabled:opacity-50"
    >
      {props.children}
    </a>
  )
  const InactiveA = props => (
    <span
      {...props}
      className="inline-block text-sm my-3 mx-1 px-4 py-2 bg-gray-100 text-gray-300 rounded-full focus:outline-none disabled:opacity-50"
    >
      {props.children}
    </span>
  )
  const CustomPagination = ({ currentRefinement, nbPages, refine, createURL, setCurrentPage }) => {
    const { t } = useTranslation()
    const prevPage = currentRefinement - 1
    const nextPage = currentRefinement + 1
    const isNextPage = nextPage <= nbPages
    console.log("currentRefinement, nbPages, ", currentRefinement, nbPages, prevPage, nextPage)
    const prevText = t('search.prev')
    const nextText = t('search.next')

    useEffect(() => {
        setCurrentPage(currentRefinement)
    }, [currentRefinement])

    return  (
        <>
            {prevPage 
                ? <A
                    href={createURL(prevPage)}
                    onClick={event => {
                        event.preventDefault()
                        refine(prevPage)
                    }}>{prevText}</A>
                : <InactiveA>{prevText}</InactiveA>
            }
            {isNextPage 
                ? <A
                    href={createURL(nextPage)}
                    onClick={event => {
                        event.preventDefault();
                        refine(nextPage);
                    }}>{nextText}</A>
                : <InactiveA>{nextText}</InactiveA>
            }
          <div className='mx-2'>{currentRefinement} {t('of')} {nbPages} {t('pages')}</div>
        </>
    )
  }
  const Pagination = connectPagination(CustomPagination)

const SearchComponent = (props) => {
    const {addProduct, onDelete, hideIds = [], facetFilters, onClose, customState, indexName, InnerButton=() => <><Plus className="h-5" />{useTranslation().t('add')}</>} = props
    const [triggerScrollToTop, setTriggerScrollToTop] = useState(false)
    const fb = useContext(FirebaseContext)
    const { t, i18n } = useTranslation()
    const [searchState, setSearchState] = useState({})
    const prevSearchState = usePrevious(searchState)

    const searchStateChange = newSearchState => {
      const { query, refinementList, page } = newSearchState
      if (JSON.stringify(newSearchState) !== JSON.stringify(searchState)) {
        if (
          prevSearchState?.query !== query ||
          prevSearchState?.refinementList !== refinementList
        ) {
          // Reset to page 1 when query or refinements change
          setTriggerScrollToTop(true)
          setSearchState({ ...newSearchState, page: 1 })
        } else {
          setTriggerScrollToTop(false)
          setSearchState(newSearchState)
        }

        // Log search event
        fb.logEvent("search", {
          search_term: newSearchState.query,
          search_page: page,
        })
      }
      
    }

    return (
  <InstantSearch 
        searchClient={indexName === "productCatalog" ? searchClient_productCatalog : searchClient} 
        indexName={indexName || i18n.language == "en" ? "us" : "de"}
        onSearchStateChange={searchStateChange}
        searchState={searchState}
        {...props}
        >
      <Configure
        hitsPerPage={12}
        facetFilters={facetFilters}
        />
            <header>
                <SearchBox onClose={onClose} defaultRefinement={customState?.query} indexName={indexName} focusOnload={props.focusOnload}/>
            </header>
            <Hits addProduct={addProduct} onDelete={onDelete} hideIds={hideIds} triggerScrollToTop={triggerScrollToTop} InnerButton={InnerButton} />
  </InstantSearch>
)};

export default SearchComponent;
